import { render, staticRenderFns } from "./OverviewLayout.vue?vue&type=template&id=2323a3fe&"
import script from "./OverviewLayout.vue?vue&type=script&lang=ts&"
export * from "./OverviewLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports